import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => [{ title: "Privacy Policy – TagFlow" }];

export default function Privacy() {
  return (
    <div
      style={{
        maxWidth: 760,
        margin: "60px auto",
        padding: "0 24px",
        fontFamily: "system-ui, sans-serif",
        lineHeight: 1.7,
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
        Privacy Policy
      </h1>
      <p style={{ color: "#666", marginBottom: 32 }}>
        Last updated: May 16, 2026
      </p>

      <h2>1. Overview</h2>
      <p>
        TagFlow ("the App") is a Shopify application that automatically applies
        tags to orders based on rules you define. This Privacy Policy explains
        how we collect, use, and protect information when you use the App.
      </p>

      <h2>2. Information We Collect</h2>
      <p>
        <strong>Order data:</strong> When the App is installed, it receives
        order data via Shopify webhooks (order total, item count, customer
        country, SKUs, discount codes). This data is processed in real time to
        evaluate your rules and is not stored beyond what is required to apply
        tags.
      </p>
      <p>
        <strong>Tagging rules:</strong> The IF/THEN rules you configure (rule
        sets, conditions, actions) are stored in our database associated with
        your shop domain.
      </p>
      <p>
        <strong>Session data:</strong> Standard Shopify session tokens are
        stored temporarily to authenticate API requests.
      </p>

      <h2>3. How We Use Information</h2>
      <ul>
        <li>
          To process incoming orders and apply tags according to your rules
        </li>
        <li>To display your rules and usage statistics in the app dashboard</li>
        <li>To authenticate your admin session</li>
      </ul>
      <p>We do not sell, rent, or share your data with third parties.</p>

      <h2>4. Data Retention</h2>
      <p>
        Rule configurations are retained until you delete them or uninstall the
        App. Order data is not persisted — it is processed in memory and
        discarded immediately after tagging. Upon uninstallation, all session
        data for your shop is deleted automatically.
      </p>

      <h2>5. Third-Party Services</h2>
      <ul>
        <li>
          <strong>Shopify</strong> — order and admin API access, governed by{" "}
          <a
            href="https://www.shopify.com/legal/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Shopify's Privacy Policy
          </a>
        </li>
        <li>
          <strong>Vercel</strong> — application hosting
        </li>
        <li>
          <strong>Neon</strong> — database hosting for rule storage
        </li>
      </ul>

      <h2>6. Security</h2>
      <p>
        All data is transmitted over HTTPS. Database access is restricted to the
        application server. We follow Shopify's security best practices for
        embedded apps.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        You may request deletion of all data associated with your shop at any
        time by uninstalling the App or contacting us at{" "}
        <a href="mailto:support@tagflow.app">support@tagflow.app</a>.
      </p>

      <h2>8. Contact</h2>
      <p>
        For privacy questions or data requests, contact us at:{" "}
        <a href="mailto:support@tagflow.app">support@tagflow.app</a>
      </p>
    </div>
  );
}
